import React from 'react';
import PropTypes from 'prop-types';
import VehicleResult from '../vehicle_search/vehicleResult';
import HorizontalScroller from '@components/application/horizontalScroller';
import { VehicleShowcaseLoading } from './VehicleShowcaseLoading';
import { VehicleShowcaseNoVehicles } from './VehicleShowcaseNoVehicles';
import Analytics from '@javascript/lib/analytics';

export const VehicleShowcaseContent = ({
  activeTab,
  experiments,
  loading,
  page,
  vehicles,
  schema,
  authenticityToken,
}) => {
  const googleAnalytics = (position, make, model) => {
    const label =
      activeTab === 'specialOffers'
        ? 'special_offers_carousel'
        : `recently_viewed_carousel`;
    Analytics.trackEvent('interaction', {
      action: `${make} ${model} at position ${position} clicked`,
      label: label,
    });
  };

  if (loading) return <VehicleShowcaseLoading />;

  if (vehicles[activeTab].length === 0) {
    return (
      <VehicleShowcaseNoVehicles
        noVehicleName={schema[activeTab]?.noVehicleName.toLowerCase()}
      />
    );
  }

  return (
    <HorizontalScroller id={`vehicle-showcase-${activeTab}`}>
      {vehicles[activeTab].map((vehicle, index) => (
        <VehicleResult
          {...vehicle}
          analytics={() => googleAnalytics(index, vehicle.make, vehicle.model)}
          authenticityToken={authenticityToken}
          experiments={experiments}
          hideImageSlider
          isShowcaseContent
          key={vehicle.stockReference}
          referrer={`${page}-${activeTab}`}
        />
      ))}
    </HorizontalScroller>
  );
};

VehicleShowcaseContent.propTypes = {
  activeTab: PropTypes.string,
  authenticityToken: PropTypes.string,
  experiments: PropTypes.object,
  loading: PropTypes.bool,
  page: PropTypes.string,
  schema: PropTypes.arrayOf(
    PropTypes.shape({
      noVehicleName: PropTypes.string,
    }),
  ),
  vehicles: PropTypes.shape({
    [PropTypes.any]: PropTypes.arrayOf(PropTypes.any),
  }),
};
